import React from "react";

// A person's name in an approval trail ("Created by X - Approved by Y"),
// coloured by the part they played so the maker and the approver can be told
// apart at a glance (2026-10-02). `action` is the trail verb as shown on the
// page ("Created", "Approved", ...); unknown verbs fall back to plain bold.
const CLASS_BY_ACTION = {
  created: "text-primary",
  requested: "text-primary",
  submitted: "text-primary",
  recorded: "text-primary",
  approved: "text-success",
  issued: "text-success",
  "credited to fund": "text-success",
  paid: "text-info",
  rejected: "text-danger",
  cancelled: "text-secondary",
};

export const actorClass = (action) => CLASS_BY_ACTION[String(action || "").trim().toLowerCase()] || "";

const ActorName = ({ action, name, className = "" }) => (
  <span className={`fw-semibold ${actorClass(action)} ${className}`.trim()}>{name}</span>
);

export default ActorName;
